var map = {
	"./blacklist.svg": 2366,
	"./coupon.svg": 7422,
	"./dashboard.svg": 8749,
	"./example.svg": 9892,
	"./eye-open.svg": 4301,
	"./eye.svg": 4986,
	"./form.svg": 4062,
	"./link.svg": 4121,
	"./nested.svg": 1476,
	"./order.svg": 3207,
	"./password.svg": 6408,
	"./sales-order.svg": 7100,
	"./table.svg": 3797,
	"./tree.svg": 964,
	"./user.svg": 42
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;